exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2KOnGVGgTj1B38EeI7FY4n{border:2px solid #000;border-radius:3px}", ""]);

// exports
exports.locals = {
	"checkbox": "_2KOnGVGgTj1B38EeI7FY4n"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/Checkbox.css
 ** module id = 1011
 ** module chunks = 0
 **/